var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2,67h0L66.8,4.4c1.1-1.1,3-1.1,4.1,0,1.1,1.1,1.1,3,0,4.1h0L8.3,71.1c-1.1,1.1-3,1.1-4.1,0-1.1-1.1-1.1-3,0-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3,4.4h0l62.6,62.6c1.1,1.1,1.1,3,0,4.1-1.1,1.1-3,1.1-4.1,0h0L4.2,8.5c-1.1-1.1-1.1-3,0-4.1,1.1-1.1,3-1.1,4.1,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.bc5323769a8dbe2a396f2d7121ea3e6f.svg";
export { ForwardRef as ReactComponent };